import {inject, Injectable} from '@angular/core';
import {EVENT_BUS} from "../../../../../shared/domain/tokens/event-bus.token";
import {Ticket} from "../../domain/model/ticket.model";
import {AccountInvoiceReceivedEvent} from 'src/app/shared/application/events/ticket/account-ticket-generated.event';
import {TicketUpdatedEvent} from 'src/app/shared/application/events/ticket/ticket-updated.event';

@Injectable({providedIn: 'root'})
export class TicketEventsService {
  private readonly eventBus = inject(EVENT_BUS);

  emitAccountInvoiceReceived(ticket: Ticket): void {
    this.eventBus.publish(new AccountInvoiceReceivedEvent(ticket));
  }

  emitTicketUpdated(ticket: Ticket | null): void {
    this.eventBus.publish(new TicketUpdatedEvent(ticket));
  }
}
